module.exports = __webpack_public_path__ + "static/img/孕产U选-详情标签@3x.ad9c390c.png";